import styled from "@emotion/styled"
import { Dialog } from "@mui/material"

const StartHereWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .new-resource-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .priority-alert {
    margin-bottom: 10px;
  }

  .empty-state {
    border: 1px dashed var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    padding: 26px 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
  }

  .resource-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0;
    padding: 10px;
    border-radius: 12px;
    overflow: hidden;
    max-width: 100%;
    border: 1px solid var(--cms-border);
    font-size: 13px;
    background: var(--cms-surface-secondary);
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);

    .thumb-container {
      position: relative;
      .chip {
        position: absolute;
        font-size: 10px;
        top: 5px;
        left: 5px;
      }
    }
    .content {
      position: relative;
      padding: 10px 12px;
      width: 100%;
      font-weight: 400;
      .title {
        font-weight: 700;
        color: var(--cms-text-primary);
      }
      p {
        color: var(--cms-text-secondary);
      }

      .actions {
        position: absolute;
        bottom: -5px;
        right: 0px;
      }
    }

    .thumb {
      max-width: 200px;
      border-radius: 10px;
    }
  }
`

const StartHereDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;

  .MuiPaper-root {
    width: min(860px, calc(100vw - 28px));
    max-width: none;
    min-height: 400px;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 48px rgba(15, 23, 42, 0.2);
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
  }

  .dialog-title-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .dialog-title {
    margin: 0;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .dialog-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 10px;
  }

  .MuiDialogActions-root {
    padding: 8px 22px 18px;
    gap: 10px;
  }

  .dialog-cancel-btn,
  .dialog-submit-btn {
    text-transform: none;
    border-radius: 10px;
    min-height: 40px;
    font-weight: 700;
    padding: 8px 14px;
  }

  .dialog-submit-btn {
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.24);
  }

  .error {
    font-size: 0.75rem;
    color: #d32f2f;
    margin-top: 3px;
  }

  .innercise {
    min-height: 250px;

    .no-selection {
      font-size: 16px;
      margin-top: 30px;
    }

    .innercise-content {
      margin-top: 20px;
      .thumb {
        max-height: 100px;
        border-radius: 8px;
        margin-bottom: 20px;
      }
      .info {
        font-size: 16px;
      }
    }
  }
`

export { StartHereWrapper, StartHereDialog }
